"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../common/utils");
const addEnvironment = (wrapperItems) => {
    return (BaseClass) => {
        return class extends BaseClass {
            getEnv() {
                return utils_1.getFirstWrapper(wrapperItems).value.environmentData;
            }
            ;
        };
    };
};
exports.addEnvironment = addEnvironment;
const addEnvironmentByName = (wrapperItems) => {
    return (wrapperName) => {
        return (BaseClass) => {
            return class extends BaseClass {
                getEnv() {
                    return utils_1.getWrapper(wrapperItems, wrapperName).environmentData;
                }
                ;
            };
        };
    };
};
exports.addEnvironmentByName = addEnvironmentByName;
const getEnv = (wrapperItems) => {
    return (wrapperName) => {
        if (wrapperName) {
            return utils_1.getWrapper(wrapperItems, wrapperName).environmentData;
        }
        else {
            return utils_1.getFirstWrapper(wrapperItems).value.environmentData;
        }
    };
};
exports.getEnv = getEnv;
//# sourceMappingURL=add-environment.js.map